import OTPList from './AppVersionList';
import {Pin} from "@mui/icons-material";

export default {
    list: OTPList,
    icon: Pin,
};
